export const isCyclic = (obj) => {
    var seenObjects = new Set();

  function detect (obj) {
    if (obj && typeof obj === 'object') {
      if (seenObjects.has(obj) !== -1) {
        return true;
      }
      seenObjects.add(obj);
      for (var key in obj) {
        if (obj.hasOwnProperty(key) && detect(obj[key])) {
          return true;
        }
      }
    }
    return false;
  }

  return detect(obj);
}

export const safeStringify = (json) => {
    if (isCyclic(json)) {
        if (Array.isArray(json)) {
            return JSON.stringify(json);
        } else {
            return "object";
        }
    }

    return JSON.stringify(json);
}
